import { QueryBoundary } from "~/components/query-boundary"
import { Route } from "~/routes/index"
import { ScrollCalendar } from "./scroll-calendar"
import { EventList } from "./event-list"
import { useCalendar } from "../hooks/use-calendar"
import { calendarQueryKeys } from "../query-keys"

export function CalendarTab() {
  return (
    <QueryBoundary>
      <CalendarFeed />
    </QueryBoundary>
  )
}

function CalendarFeed() {
  const { data } = useCalendar()
  const { eventId } = Route.useSearch()
  const navigate = Route.useNavigate()
  const consumeEventId = () => navigate({ search: (s) => ({ ...s, eventId: undefined }), replace: true })

  return (
    <ScrollCalendar events={data}>
      <EventList events={data} queryKey={calendarQueryKeys()} eventId={eventId} onConsumeEventId={consumeEventId} />
    </ScrollCalendar>
  )
}
